import React, {PropTypes} from 'react';
import {connect} from 'react-redux';

import {emailValidation, passwordValidation} from '../../../utils/itemValidation';
import {saveLogin} from '../../../utils/auth';

import * as authConstants from '../../../constants/auth';

import * as authActionCreators from '../../../actions/auth';
import * as commonActionCreators from '../../../actions/common';
import * as userActionCreators from '../../../actions/user';
let allActionCreators = Object.assign({}, authActionCreators, commonActionCreators, userActionCreators);

class Login extends React.Component {

	static propTypes = {
    location: PropTypes.object
  };

  static contextTypes = {
    store: PropTypes.any,
    router: React.PropTypes.object.isRequired
  };

	constructor(props) {
		super(props);
		this.state = {

      requestPending: false,
      serverError: null,

      email: '',
      password: '',
      emailError: null,
      passwordError: null,

      forgotMode: false,
    };
	}

	componentDidMount() {

  }

  internalNav(page) {
    this.context.router.push('/' + page);
  }

	externalNav(page) {
    window.location.href = '/' + page;
  }

  openNew(page) {
    let win = window.open(page, '_blank');
    win.focus();
  }

  closeLogin() {
    this.props.commonCloseLogin();
  }

  changeEmail(evt) {
    this.setState({ email: evt.target.value });
  }

  changePassword(evt) {
    this.setState({ password: evt.target.value });
  }

  validateEmail() {
    this.setState({ emailError: emailValidation(this.state.email) });
  }

  validatePassword() {
    this.setState({ passwordError: passwordValidation(this.state.password) });
  }

  validateAll() {
    let emailError = emailValidation(this.state.email);
    let passwordError = passwordValidation(this.state.password);

    this.setState({
      emailError: emailError,
      passwordError: passwordError,
    });
    if(
      emailError === null &&
      passwordError === null
    ) {
      return true;
    } else {
      return false;
    }
  }

  handleSubmit(evt) {
    evt.preventDefault();

    if(this.validateAll()) {

      this.setState({
        requestPending: true,
        serverError: null,
      });

      this.props.authLogin(this.state.email, this.state.password)
      .then((resp) => {
        this.setState({
          requestPending: false,
          serverError: null,

          email: '',
          password: '',
          emailError: null,
          passwordError: null,
        }, () => {

          saveLogin(resp);
          this.props.authSave(resp, Date.now() + authConstants.LOGOUT_TIME);

          setTimeout(() => {
            this.props.userGetUser()
            .then((resp) => {
              
              console.log('userGetUser');
              console.log(resp);
              
              this.props.userSaveCore(resp);
            });
          }, 25);

          this.internalNav('account');
          this.closeLogin();
        });
      })
      .catch((resp) => {
        this.setState({
          requestPending: false,
          serverError: 'Incorrect email/password combination.',
        });
      });
    } 
  }

  validateEmail() {
    let emailError = emailValidation(this.state.email);

    this.setState({
      emailError: emailError,
    });
    return emailError === null;
  }

  handleForgotSubmit(evt) {
    evt.preventDefault();

    if(this.validateEmail()) {

      this.setState({
        requestPending: true,
        serverError: null,
      });

      this.props.userForgotPassword(this.state.email)
      .then((resp) => {
        this.setState({
          requestPending: false,
          serverError: null,

          email: '',
          password: '',
          emailError: null,
          passwordError: null,
        });
        this.props.commonAlert('If there is an account associated with this email address, we will send an email with instructions for resetting your password.', 'Continue', 'default');
      })
      .catch((resp) => {
        this.setState({
          requestPending: false,
          serverError: null,
        });
        this.props.commonAlert('If there is an account associated with this email address, we will send an email with instructions for resetting your password.', 'Continue', 'default');
      });
    } 
  }

  handleToggle(evt) {
    evt.stopPropagation();
    this.props.toggleMethod();
  }

  toggleForgot() {
    this.setState({
      forgotMode: !this.state.forgotMode,
      emailError: null,
      passwordError: null
    });
  }

	render() {
		return <div className='Login'>
      <div className='loginClose' onClick={::this.closeLogin}>
        <div className='closeX'>&times;</div>
      </div>
      {this.state.forgotMode ? 
        <div className='loginInnerWrapper'>
          <div className='loginTitle'>Forgot Password?</div>
          <div className='loginHr'></div>
          <div className='loginText'>Enter your email to reset your password, and we will send you a link to reset your password.</div>
          <div className='loginFormWrapper'>
            <form className='loginForm' onSubmit={::this.handleForgotSubmit}>
              {this.state.serverError ?
                <div className='loginFormError'>{this.state.serverError}</div> :
                null
              }
              <div className='loginFormRow'>
                <div className='loginInputLabel'>
                  <label htmlFor='authForgotEmail'>
                    Email
                  </label>
                </div>
                <input 
                  id='authForgotEmail'
                  type='email'
                  className={this.state.emailError ? 'error' : ''}
                  value={this.state.email}
                  onChange={::this.changeEmail}
                  onBlur={::this.validateEmail} />
                {this.state.emailError ?
                  <div className='loginInputError'>{this.state.emailError}</div> :
                  null
                }
              </div>

              <div className='forgotPasswordRow'><span onClick={::this.toggleForgot}>Back to Login</span></div>
              <div className='loginFormRow'>
                <div className='loginFormButtonWrapper'>
                  <button 
                    className={'loginFormButton dd2ActionButton'}
                    disabled={this.state.requestPending}
                    type='submit'>Reset</button>
                </div>
              </div>
            </form>
          </div>
        </div> :
        <div className='loginInnerWrapper'>
          <div className='loginTitle'>Sign In</div>
          <div className='loginHr'></div>
          <div className='loginText'>Welcome back to Diamonds Direct please sign into your online account</div>
          <div className='loginFormWrapper'>
            <form className='loginForm' onSubmit={::this.handleSubmit}>
              {this.state.serverError ?
                <div className='loginFormError'>{this.state.serverError}</div> :
                null
              }
              <div className='loginFormRow'>
                <div className='loginInputLabel'>
                  <label htmlFor='authEmail'>
                    Email
                  </label>
                </div>
                <input 
                  id='authEmail'
                  type='email'
                  className={this.state.emailError ? 'error' : ''}
                  value={this.state.email}
                  onChange={::this.changeEmail}
                  onBlur={::this.validateEmail} />
                {this.state.emailError ?
                  <div className='loginInputError'>{this.state.emailError}</div> :
                  null
                }
              </div>
              <div className='loginFormRow'>
                <div className='loginInputLabel'>
                  <label htmlFor='authPass'>
                    Password
                  </label>
                </div>
                <input 
                  id='authPass'
                  type='password'
                  className={this.state.passwordError ? 'error' : ''}
                  value={this.state.password}
                  onChange={::this.changePassword}
                  onBlur={::this.validatePassword} />
                {this.state.passwordError ?
                  <div className='loginInputError'>{this.state.passwordError}</div> :
                  null
                }
              </div>
              <div className='forgotPasswordRow'><span onClick={::this.toggleForgot}>Forgot Password?</span></div>
              <div className='loginFormRow'>
                <div className='loginFormButtonWrapper'>
                  <button 
                    className={'loginFormButton dd2ActionButton'}
                    disabled={this.state.requestPending}
                    type='submit'>Sign In</button>
                </div>
              </div>
            </form>
          </div>
          <div className='toggleArea'>
            <div className='toggleText'>Don't have a Diamonds Direct online account?</div>
            <div className='toggleLink' onClick={::this.handleToggle}>Create an account.</div>
          </div>
        </div>
      }
		</div>;
	}
}
export default Login;

function mapStateToProps(state) {
  return {

  };
}

export const LoginContainer = connect(
  mapStateToProps,
  allActionCreators
)(Login);


// WEBPACK FOOTER //
// ./src/components/views/login/Login.jsx